var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"financiamiento-view"},[_c('ComingSoon',{attrs:{"label":_vm.sectionContent.label,"description":_vm.sectionContent.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }